import React, { useEffect } from "react";
import { useApp } from 'common/AppContext';
import { Container, Image } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { FaClock } from "react-icons/fa";

import logo from "common/assets/logo_gmetrix.png";

const SessionLimit = props => {

    const { setLocale } = useApp();

    const { location } = props;
    const ctag = new URLSearchParams(location?.search).get('ctag');

    useEffect(() => {

        if (ctag)
            setLocale(ctag);

    }, []);

    return (
        <div
            style={{
                width: '100vw',
                height: '100vh',
                overflow: 'hidden',
                position: 'absolute',
                left: 0,
                top: 0,
                zIndex: 1
            }}
            >
            <Container
                fluid
                className="d-flex justify-content-center align-items-center min-vh-100"
            >
                <div className="text-center" style={{ maxWidth: 420 }}>
                    <div>
                        <Image src={logo} width={200} className="mb-5" />
                    </div>
                    <FaClock size={45} className="text-secondary mb-4" />
                    <h5 className="mb-3">
                        <FormattedMessage defaultMessage="You have too many testing sessions open" id="label.you_have_too_many_testing_sessions.ede1597c" />
                    </h5>
                    <p>
                        <FormattedMessage defaultMessage="You've reached the maximum number of cloud testing sessions you can have open at the same time. Please close one of your other sessions, then wait a few minutes and try again." id="label.youve_reached_the_maximum_number_o.c7151d96" />
                    </p>
                </div>
            </Container>
        </div>
    );

};

export default SessionLimit;
